export default {
  label: 'Altura',
};
